var map = {
	"./demo_1_and.png": "f6e6",
	"./demo_1_or.png": "3788",
	"./demo_2_and.png": "3f9e",
	"./demo_2_or.png": "94a7",
	"./demo_3_and.png": "9086",
	"./demo_3_or.png": "f518"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "548f";